import { Formik } from "formik";

import { useAddSoftwareLicenceMutation } from "@sso/apis/softwareLicences";
import { DialogHeader } from "@sso/components/Dialogs/components";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectSoftwareLicenceId } from "@sso/store/slices/softwareLicence";
import {
  LicenceType,
  PricingRuleCreateRequest,
  SoftwareLicenceCreateRequest,
  SoftwareLicenceFormValues,
  SoftwareLicenceSummaryKeys,
} from "@sso/types";

import LicenceTypeAddForm from "./addForm";
import { licenceTypeSchemeValidation } from "./schema";

export interface ApiPricingRules {
  billableOperationId: string;
  pricingRules: PricingRuleCreateRequest[];
}

const LicenceTypeAddDialog = () => {
  const [addSoftwareLicence, { isLoading: addLoading }] = useAddSoftwareLicenceMutation();

  const softwareId = useAppSelector(selectSoftwareLicenceId);

  const handleSubmit = (values: SoftwareLicenceFormValues) => {
    if (values.licenceType === LicenceType.API) {
      values.pricingRules = values.apiPricingRules?.reduce((acc: any, curr: any) => {
        const pricingRules = curr.pricingRules.map((rule: any) => {
          return { ...rule, billableOperationId: curr.billableOperationId };
        });
        return [...acc, ...pricingRules];
      }, []);
    }

    const request: SoftwareLicenceCreateRequest = {
      name: values[SoftwareLicenceSummaryKeys.NAME]!,
      licenceType: values[SoftwareLicenceSummaryKeys.LICENCE_TYPE]!,
      paymentType: values[SoftwareLicenceSummaryKeys.PAYMENT_TYPE]!,
      expiryTimeValue: values.expiryTimeValue!,
      expiryTimeUnit: values.expiryTimeUnit!,
      defaultConcurrentUsers: values.defaultConcurrentUsers!,
      featureHtml: values.featureHtml,
      softwareId: softwareId,
      pricingRules: values.pricingRules?.map(rule => ({
        ...rule,
        currencyCode: "GBP",
      })),
    };

    addSoftwareLicence(request);
  };

  const initialValues: SoftwareLicenceFormValues = {
    [SoftwareLicenceSummaryKeys.NAME]: undefined,
    [SoftwareLicenceSummaryKeys.LICENCE_TYPE]: undefined,
    [SoftwareLicenceSummaryKeys.PAYMENT_TYPE]: undefined,
    expiryTimeUnit: undefined,
    expiryTimeValue: undefined,
    defaultConcurrentUsers: undefined,
    pricingRules: [],
    featureHtml: undefined,
  };

  return (
    <>
      <DialogHeader title={"Add Licence Type"} />
      <Formik onSubmit={handleSubmit} initialValues={initialValues} validationSchema={licenceTypeSchemeValidation}>
        <LicenceTypeAddForm />
      </Formik>
    </>
  );
};

export default LicenceTypeAddDialog;
